app.factory('companyService', ['$http', '$location', function($http, $location) {
    return {
        get : function(id) {
            return $http
            .get('api/companies/' + id)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        add: function(company){
            return $http
            .post('api/companies/add', company)
            .then(res => {
                alert.success("New company saved successfully!");
                $location.path("/companies/");

                return res.data;
            }, errorHandler);
        },

        find: function(filter){
            return $http
            .post('api/companies/', filter)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        update: function(company){
            return $http
            .put('api/companies/', company)
            .then(res => {
                alert.success("Company updated successfully!")
                $location.path("/companies");

                return res.data;
            }, errorHandler);
        },

        remove: function(id){
            if(confirm("Are you sure?")){

            return $http
            .delete('api/companies/' + id)
            .then(() => {
                alert.success("Company deleted successfully!")
                $location.path("/companies");
            }, errorHandler);
        }
        }
    };
} ]);
